import {CALL_SERVICE_TO_GET_LIST, SET_CATEGORIES} from '../actions/category'
import CategoryService from "../../services/CategoryService";


const state = {
    categories: []
};

const getters = {
    getListCategories: state => state.categories,
};

const actions = {
    [CALL_SERVICE_TO_GET_LIST]: async ({commit}) => {
        const payload = (await CategoryService.getList()).data.payload
        const categories = payload ? payload.categories : []
        commit(SET_CATEGORIES, categories);
    }
};

const mutations = {
    [SET_CATEGORIES]: (state, categories) => {
        state.categories = categories
    }
};

export default {
    state,
    getters,
    actions,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/category.js